import { initGraphQLTada } from 'gql.tada';
export const graphql = initGraphQLTada();
